module.exports = __webpack_public_path__ + "static/media/34DSS11.2ae5e71a.jpg";